import Auth from "./auth.store";
import ListDT from "./listdt.store";
import DT from "./dt.store";
import DT_HISTORY from "./history.dt.store";
import Options from "./options.store";
import FR_SERVER from "./frserver.store";

export default {
  Auth,
  FR_SERVER, 
  ListDT,
  DT,
  DT_HISTORY,
  Options
};